import { useState, useCallback, useEffect } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { fetchAllPostOpStatuses } from '../api/postOpHubApi';

export const usePostOpHub = (uhidNo) => {
  const queryClient = useQueryClient();

  const getFormStatus = useCallback((apiResponse) => {
    if (apiResponse.status === 'fulfilled') {
      const data = apiResponse.value.data;
      if (data && Object.keys(data).length > 0) {
        return 'complete';
      }
    }
    
    // Check for draft in session storage (ignoring the specific draft logic for now as it varies by form)
    // In actual implementation, we'd check against DRAFT_KEYS if mapping is consistent
    return 'not-started';
  }, []);

  const { data: statuses, isLoading, refetch } = useQuery({
    queryKey: ['postOpStatuses', uhidNo],
    queryFn: () => fetchAllPostOpStatuses(uhidNo),
    enabled: !!uhidNo,
    select: (data) => ({
      postOperativeOrders: getFormStatus(data[0]),
      postOperativeInstructions: getFormStatus(data[1]),
      postAnaesthesiaRecovery: getFormStatus(data[2]),
      analgesiaAssessment: getFormStatus(data[3]),
      postOperativeHandover: getFormStatus(data[4])
    })
  });

  const completionCount = statuses ? Object.values(statuses).filter(s => s === 'complete').length : 0;
  const totalCount = statuses ? Object.values(statuses).length : 5;
  const progressPercentage = (completionCount / totalCount) * 100;

  return {
    statuses,
    isLoading,
    refetch,
    completionCount,
    totalCount,
    progressPercentage
  };
};
